import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
import { WintSuperkollAPIModelCustomFilters } from "wint-api-client/dist/types";
//#endregion
//#region components
import { DashboardButtonGroup, FilterButton, PageLayouts, ReloadEvent, StyledButton } from "components/common";
import useCreateAgreementDialog from "./forms/useCreateDialog";
import AgreementsList from "./listView";
import useAgreementReportFilterDefinition from "./useReportFilterDefinition";
import { Grid } from "@mui/material";
import { useAgreementService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const AgreementsReport: React.FC = () => {
  const agreementService = useAgreementService();

  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const {
    filterFormFields: reportFilterDefinition,
    filterQueryStateHandler,
    apiToReportFilterFormatter,
  } = useAgreementReportFilterDefinition();

  const getCreateDialog = useCreateAgreementDialog();

  const onCreateAgreementClick = (onSubmitSuccess?: () => void) => {
    dispatch(displayDialog(getCreateDialog(undefined, onSubmitSuccess)));
  };

  return (
    <ReloadEvent
      render={(reloadKey, reload) => (
        <PageLayouts.DashboardLayout
          entityKey={0}
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Agreement.Agreements)}
          topRightButtons={
            <DashboardButtonGroup
              buttons={[
                <StyledButton size="sm" onClick={onCreateAgreementClick.bind(null, reload)}>
                  {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Agreement.AddAgreement)}
                </StyledButton>,
                ACTION_SEPARATOR,
                <FilterButton />,
              ]}
            />
          }
          initialFilter={{
            active: true,
          }}
          filterFields={reportFilterDefinition}
          filterQueryStateHandler={filterQueryStateHandler}
          apiToReportFilterFormatter={apiToReportFilterFormatter}
          reportToAPIFilterFormatter={agreementService.reportToAPIFilter}
          filterCategory={WintSuperkollAPIModelCustomFilters.FilterCategory.Agreement}
        >
          <Grid container item>
            <AgreementsList reloadKey={reloadKey} reloadList={reload} />
          </Grid>
        </PageLayouts.DashboardLayout>
      )}
    />
  );
};

export default AgreementsReport;
